import { Effect, Schema as S } from "effect";

import { Cadence } from "./records";

/** Server `GET /keep-in-touch` payload (KTD7). Optional fields decode leniently. */
export const CardRecord = S.Struct({
	id: S.String,
	name: S.String,
	type: S.String,
	avatars: S.Array(S.String),
	subtitle: S.optionalKey(S.NullOr(S.String)),
});

export const Reason = S.Struct({
	cadence: S.optionalKey(Cadence),
	daysSinceContact: S.NullOr(S.Number),
	overdue: S.Boolean,
});
export type Reason = typeof Reason.Type;

export const LatestEntry = S.Struct({
	id: S.String,
	title: S.String,
	snippet: S.String,
	timestamp: S.String,
});

export const Card = S.Struct({
	record: CardRecord,
	reason: Reason,
	context: S.Struct({
		latestEntry: S.optionalKey(LatestEntry),
		openTasks: S.Number,
	}),
	cleared: S.Boolean,
});
export type Card = typeof Card.Type;

export const Tracked = S.Struct({
	id: S.String,
	name: S.String,
	type: S.String,
	cadence: Cadence,
	paused: S.Boolean,
	lastContact: S.NullOr(S.String),
	nextDue: S.NullOr(S.String),
});
export type Tracked = typeof Tracked.Type;

/** `cadence` is always on the wire; the server nulls it for a paused record without one. */
export const Paused = S.Struct({
	id: S.String,
	name: S.String,
	type: S.String,
	cadence: S.NullOr(Cadence),
});
export type Paused = typeof Paused.Type;

/** An open task across the circle (KTD5), newest entry first, at most ten. */
export const OpenTask = S.Struct({
	id: S.String,
	text: S.String,
	createdAt: S.String,
	entryId: S.String,
	record: S.Struct({ id: S.String, name: S.String }),
});
export type OpenTask = typeof OpenTask.Type;

export const Week = S.Struct({
	week: S.String,
	cards: S.Array(Card),
	tracked: S.Array(Tracked),
	paused: S.Array(Paused),
	/** Absent on older servers (R13): decodes to an empty list. */
	openTasks: S.Array(OpenTask).pipe(
		S.withDecodingDefaultKey(Effect.succeed([] as ReadonlyArray<OpenTask>)),
	),
});
export type Week = typeof Week.Type;
